module.exports = __webpack_public_path__ + "img/0.dedf89c6.jpg";